import { BindType } from './type';
import type { EventData, EVENT_NAME } from './type';

export class EventBus {
  static __instance: EventBus;
  private subscribeList: { [name in EVENT_NAME]?: Array<EventData<any>> } = {};
  constructor() {
    if (EventBus.__instance) return EventBus.__instance;
    EventBus.__instance = this;
  }
  readonly publish = <DATA>(eventName: EVENT_NAME, data?: DATA) => {
    const list = this.subscribeList[eventName] || [];
    this.subscribeList[eventName] = list.filter((item) => {
      const { callback } = item;
      callback?.(data);
      return item.bindType !== BindType.once;
    });
  };
  readonly bind = <T>(args: Omit<EventData<T>, 'bindType'>) => {
    const { eventName } = args;
    if (!this.subscribeList[eventName]) {
      this.subscribeList[eventName] = [];
    }
    this.subscribeList[eventName]?.push({
      ...args,
      bindType: BindType.common,
    });
  };
  readonly bindOnce = <T>(args: Omit<EventData<T>, 'bindType'>) => {
    const { eventName } = args;
    if (!this.subscribeList[eventName]) {
      this.subscribeList[eventName] = [];
    }
    this.subscribeList[eventName]?.push({
      ...args,
      bindType: BindType.once,
    });
  };
  readonly unBind = <T>(eventName: EVENT_NAME, callback: (args: T) => void) => {
    this.subscribeList[eventName] = (this.subscribeList[eventName] || []).filter(
      (item) => item.callback !== callback
    );
  };
}
